import { render } from "./CreateSmsConfig.vue?vue&type=template&id=2344dd6e"
import script from "./CreateSmsConfig.vue?vue&type=script&lang=js"
export * from "./CreateSmsConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__